export const Z_INDEXES = {
  // MUI's Fabs have a 1050 z-index, we need to be above that so the FABs don't show over the group steps card
  GROUP_STEPS: 1051
};
